import React, { useEffect, useState } from "react";
import DashboardLayout from "../../Layout/DashboardLayout";
import { Typography, Button, Box, TextField } from "@mui/material";
import { get } from "../../utils/api";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MainDashboardLayout from "../../Layout/MainDashboardLayout";
import MainSidebar from "../../Layout/MainSidebar";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../context/AuthContext";
import Unauthorized from "../../Components/Unauthorized/Unauthorized";
import GroupAdminSidebar from "../../Layout/GroupAdminSidebar";
import useAuthStore from "../../store/ContextUser";
const FAQ = () => {
  const { user, module } = useUser();
  const { selectedCompany } = useAuthStore();
  let hasAccess =
    user?.companyAdmin || user?.facilityManger || module?.includes("Setup");
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();
  const [question, setQuestion] = useState([]);
  const [downState, setDownState] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const Questions = async () => {
    await get(`/support/FAQ/user/faq`)
      .then((res) => {
        console.log(res.data.data);
        setQuestion(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // Track which question is open

  // useEffect(()=>{
  //   setQuestion(question?.find(el=>el===searchQuery))
  // },[searchQuery])

  useEffect(() => {
    if (searchQuery) {
      const matchedQuestions = question?.filter((el) =>
        el?.question?.toLowerCase().includes(searchQuery.toLowerCase())
      );
      console.log(
        matchedQuestions,
        "matchedQuestions",
        searchQuery,
        matchedQuestions?.length
      ); // Logs all matching objects
      setQuestion(matchedQuestions);
    } else Questions();
  }, [searchQuery]);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index); // Toggle active index
  };
  useEffect(() => {
    Questions();
  }, []);
  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      {/* <Unauthorized requiredModule="FAQ"> */}
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            margin: "2rem 0",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#000000",
              marginBottom: "2rem",
              marginTop: "20px",
              // textTransform: "uppercase",
              letterSpacing: "-0.5px",
              lineHeight: "1.2",
              cursor: "pointer",
              transition: "0.3s",
            }}
          >
            Frequently Asked Questions
          </Typography>
          <TextField
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="🔍 Search"
            fullWidth
            size="small"
            variant="outlined"
            sx={{
              backgroundColor: "#FFFFFF",
              borderRadius: "4px",
              width: "35%",
              height: "2.5rem",
              mt: "1rem",
            }}
          />
        </Box>
        <Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              border: "1.3px solid #1C486B",
              background: "#fff",
              alignItems: "center",
              textAlign: "center",
              padding: { xs: "5px", sm: "10px" },
              borderRadius: "8px",
              boxSizing: "border-box",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: "10px", sm: "0" },
              height: { xs: "auto", sm: "70px" },
            }}
          >
            <Typography
              component="span"
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                paddingLeft: "1.5%",
                fontFamily: "inter",
              }}
            >
              Still Facing Issues? Get help by Raising Ticket
            </Typography>

            <Button
              onClick={() => navigate("/ticket")}
              sx={{
                background: "#1C486B",
                color: "#fff",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "20px",
                width: "20%",
                borderRadius: "5px",
                marginRight: "2%",
                size: "small",
                textTransform: "capitalize",
                "&:hover": {
                  background: "#1C486B",
                },
              }}
            >
              Go to Support Section
            </Button>
          </Box>
        </Box>

        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "1.2rem",
            marginTop: "1rem",
          }}
        >
          {question.map((item, index) => {
            return (
              <Accordion
                key={index}
                expanded={activeIndex === index}
                onChange={() => handleToggle(index)}
                disableGutters
                sx={{
                  border: "none",
                  borderRadius: "8px",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                  marginBottom: "0px !important",
                }}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon sx={{ fontSize: "26px" }} />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{
                    paddingRight: "2.5%",
                    borderTop: "none",
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 600,
                      fontSize: "14px",
                      lineHeight: "20px",
                      paddingLeft: "1.2%",
                      fontFamily: "inter",
                    }}
                  >
                    Q. {item?.question}
                  </Typography>
                </AccordionSummary>
                {/* <AccordionDetails
        sx={{
          marginTop: "-0.5rem",
          paddingLeft: "2.8%",
          paddingRight: "3%",
          marginBottom: "0 !important",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "21px",
          fontFamily: "inter",
          display:"flex"
        }}
      >
        <p style={{ fontWeight: 600,
            fontSize: "14px",marginRight:"10px"}}>A.</p>
       {item?.answer?.split('')}
      </AccordionDetails> */}
                <AccordionDetails
                  sx={{
                    marginTop: "-0.5rem",
                    padding: "6px 7px 16px",
                    paddingLeft: "2.8%",
                    paddingRight: "1.5%",
                    marginBottom: "0 !important",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "21px",
                    fontFamily: "inter",
                    display: "flex",
                  }}
                >
                  <p
                    style={{
                      fontWeight: 600,
                      fontSize: "14px",
                      marginRight: "0px",
                    }}
                  >
                    A.
                  </p>
                  <AccordionDetails
                    sx={{
                      marginTop: "-0.5rem",
                      paddingRight: "3%",
                      marginBottom: "0 !important",
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "21px",
                      fontFamily: "inter",
                      display: "block",
                    }}
                  >
                    {item?.answer?.split("\n").map((line, index) => (
                      <div
                        key={index}
                        style={{ display: "flex", marginBottom: "4px" }}
                      >
                        {/* <p style={{ fontWeight: 600, fontSize: "14px", marginRight: "6px" }}>
        ({String.fromCharCode(97 + index)}).
      </p> */}
                        <p style={{ margin: 0 }}>{line}</p>
                      </div>
                    ))}
                  </AccordionDetails>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>
      </Box>

      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.2rem",
          marginTop: "1rem",
          marginBottom: "2rem",
        }}
      >
        {question.map((item, index) => {
          return (
            <Accordion
              key={index}
              expanded={activeIndex === index}
              onChange={() => handleToggle(index)}
              disableGutters
              sx={{
                border: "none",
                borderRadius: "8px",
                boxShadow: "none",
                "&:before": { display: "none" },
                marginBottom: "0px !important",
              }}
            >
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon sx={{ fontSize: "26px" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{
                  paddingRight: "2.5%",
                  borderTop: "none",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 600,
                    fontSize: "14px",
                    lineHeight: "20px",
                    paddingLeft: "1.2%",
                    fontFamily: "inter",
                  }}
                >
                  {item?.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  marginTop: "-0.5rem",
                  paddingLeft: "2.8%",
                  paddingRight: "3%",
                  marginBottom: "0 !important",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "21px",
                  fontFamily: "inter",
                }}
              >
                {item?.answer}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default FAQ;
